// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"3f6941f7","4669":"2c4fa35e","8883":"6bdf6d2a"}[chunkId] + ".chunk.css";
};